<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Seo</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <router-link to="/seo/add" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Add Seo
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Info</h6>
            </div>
            <div class="table-responsive">
              <div class="section section-service-info">
                <div class="">
                  <div class="service-info">
                    <div class="service-info__preview">
                      <b-table striped hover :items="seoList" :fields="tableFields">
                        <template #cell(metaImage_path)="row">
                          <div v-if="row.item.metaImage_path">
                            <img class="img-thumbnail table-image" :src="row.item.metaImage_path" alt="image">
                          </div>
                        </template>
                        <template #cell(actions)="row">
                          <router-link :to="`seo/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                            <i class="fe fe-edit"></i>
                          </router-link>
                          <button @click="removeFaq(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                            <i class="ti-close"></i>
                          </button>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'seo',
  computed: {
    ...mapState({
      seoList: state => state.seo.seoList
    }),
    tableFields () {
      return [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          label: 'Meta Image',
          key: 'metaImage_path',
          sortable: false
        },
        {
          key: 'page',
          label: 'Page',
          sortable: true
        },
        {
          key: 'title.' + this.$i18n.locale,
          label: 'Title',
          sortable: true
        },
        {
          key: 'meta_title.' + this.$i18n.locale,
          label: 'Meta Title',
          sortable: true
        },
        {
          key: 'meta_description.' + this.$i18n.locale,
          label: 'Meta Description',
          sortable: true,
          class: 'description'
        },
        {
          key: 'actions',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getSeoList().then(res => {
      this.seoList = res
    })
  },
  methods: {
    ...mapActions({
      getSeoList: 'seo/getSeoList',
      deleteItem: 'seo/deleteItem'
    }),
    removeFaq (id) {
      this.deleteItem(id)
    }
  }
}
</script>
